<template>
    <el-table
        v-loading="isLoading"
        :data="data"
        class="row-click ah-el-data-table salary-page-staff-table"
        show-summary
        :summary-method="getSummaries"
        @row-click="$event => $emit('row-click', $event)"
    >
        <el-table-column prop="month" label="所屬月份" width="130" sortable fixed type="date">
            <template slot-scope="scope">
                <span class="strong">{{ scope.row.year }} 年 {{ scope.row.month }} 月</span>
            </template>
        </el-table-column>

        <!-- 勞保費 -->
        <el-table-column prop="labor" label="勞保費" align="center">
            <el-table-column prop="payroll" label="受僱者當月投保總金額" sortable align="right" width="180">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.labor.payroll" />
                    </div>
                    <div class="sub-numbers">
                        <el-tooltip class="item" effect="dark" content="投保人數" placement="bottom">
                            <span> {{ scope.row.labor.headcount }} 人 </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="公司負擔" sortable align="right">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.labor.amt" />
                    </div>
                    <div class="sub-numbers">
                        <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                            <span>
                                {{ scope.row.labor.paY_DAT | dateFormater("YYYY-MM-dd") }}
                            </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table-column>

        <!-- 二代健保 -->
        <el-table-column prop="secondHealth" label="二代健保" align="center">
            <el-table-column prop="headcount" label="人數" width="75" align="right" type="headcount">
                <template slot-scope="scope">
                    <Money :v="scope.row.secondHealth.headcount" />
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="公司負擔" sortable align="right">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.secondHealth.amt" />
                    </div>
                    <div class="sub-numbers">
                        <el-tooltip class="item" effect="dark" content="繳款日期" placement="bottom">
                            <span>
                                {{ scope.row.secondHealth.paY_DAT | dateFormater("YYYY-MM-dd") }}
                            </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table-column>

        <!-- 健保費 -->
        <el-table-column prop="health" label="健保費" align="center">
            <el-table-column prop="payroll" label="受僱者當月投保總金額" sortable align="right" width="180">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.health.payroll" />
                    </div>
                    <div class="sub-numbers">
                        <el-tooltip class="item" effect="dark" content="投保人數" placement="bottom">
                            <span> {{ scope.row.health.headcount }} 人 </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="公司負擔" sortable align="right">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.health.amt" />
                    </div>
                    <div class="sub-numbers">
                        <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                            <span>
                                {{ scope.row.health.paY_DAT | dateFormater("YYYY-MM-dd") }}
                            </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table-column>

        <!-- 退休金 -->
        <el-table-column prop="pension" label="退休金" align="center">
            <el-table-column prop="payroll" label="提繳金額" sortable align="right">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.pension.payroll" />
                    </div>
                    <div class="sub-numbers">{{ scope.row.pension.headcount }} 人</div>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="公司負擔 (6%)" sortable align="right">
                <template slot-scope="scope">
                    <div class="primary-number">
                        <Money :v="scope.row.pension.amt" />
                    </div>
                    <div class="sub-numbers">
                        <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                            <span>
                                {{ scope.row.pension.paY_DAT | dateFormater("YYYY-MM-dd") }}
                            </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    methods: {
        getColSum(allData, path) {
            // 取得各月份數字為陣列
            const numbers = allData.map((item) => Number(_.get(item, path)));

            // 加總
            const sum = numbers.reduce((prev, curr) => {
                const value = Number(curr);
                if (!Number.isNaN(value)) {
                    return prev + curr;
                }
                return prev;
            }, 0);

            // 加千分位
            let formatedSum = sum;
            if (!Number.isNaN(formatedSum)) {
                formatedSum = Number.parseInt(formatedSum, 10).toLocaleString('en-US');
            }
            return formatedSum;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            sums[0] = '總計';

            // 勞保費 / 受僱者當月投保總金額, 公司負擔
            sums[1] = this.getColSum(data, 'labor.payroll');
            sums[2] = this.getColSum(data, 'labor.amt');

            // 二代健保 / 人數, 公司負擔
            sums[3] = this.getColSum(data, 'secondHealth.headcount');
            sums[4] = this.getColSum(data, 'secondHealth.amt');

            // 健保 / 受僱者當月投保總金額, 公司負擔
            sums[5] = this.getColSum(data, 'health.payroll');
            sums[6] = this.getColSum(data, 'health.amt');

            // 退休金 / 提繳金額, 公司負擔
            sums[7] = this.getColSum(data, 'pension.payroll');
            sums[8] = this.getColSum(data, 'pension.amt');

            return sums;
        },
    },
};
</script>
<style lang="scss">
.salary-page-staff-table {
    .el-table__header-wrapper tbody td,
    .el-table__footer-wrapper tbody td {
        // background-color: #fff;
        // border-top: 1px solid #ccc;
        font-weight: bold;
    }
}
</style>
